<footer class="site-footer">
  <div class="footerWrap footer-bg">
    <div class="footer-content">
      <div class="row ">
        <div class="col-md-3 ftr-about">
          <div class="ftr-site-logo">
            <figure>
              <a href="#">
                <img src="assets/images/footer-logo.svg" />
              </a>
            </figure>
          </div>
          <div class="ftr-contact">
            <div class="social">
              <h5>CONNECT WITH US</h5>
              <ul>
                <li><a href="#" target="_blank"><img src="assets/images/insta-icon.svg"></a></li>
                <li><a href="#" target="_blank"><img src="assets/images/youtube.svg"></a></li>
                <li><a href="#" target="_blank"><img src="assets/images/pint-icon.svg"></a></li>
                <li><a href="#"target="_blank"><img src="assets/images/facebook.svg" ></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-8 ftr-links">
          <div class="row">
            <div class="col-6">
              <div class="links-blk">
                <h4 class="l-title">about us</h4>
                <ul>
                  <li><a href="our-story">our story</a></li>
                  <li><a href="career">careers</a></li>
                  <li><a href="terms-of-service">terms & conditions</a></li>
                  <li><a href="privacy-policy">privacy policy</a></li>
                  <li><a href="blog">blogs</a></li>
                </ul>
              </div>
            </div>
            <div class="col-6">
              <div class="links-blk">
                <h4 class="l-title">customer care</h4>
                <ul>
                  <li><a href="faq">faq</a></li>
                  <li><a href="shipping-policy">Shipping</a></li>
                  <li><a href="returns-and-refund">Return & Exchange</a></li>
                  <li><a href="contact-us">contact us</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 ftr-newsletter ">
          <div class="form-blk">
            <h4>You’ve Got Mail…</h4>
            <div class="input01" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"
              [ngClass]="showError && email.errors && (email.errors?.['required'] || email.errors?.['pattern']) ? 'showError' : ''">
              <input type="email" #email="ngModel" 
              [class.is-invalid]="email.invalid && email.touched" 
              required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" 
              placeholder="Email Address" (input)="changeEmail($event)"
              [(ngModel)]="emailSubscribe" (keyup.enter)="subscribeEmail(email.errors)">
              <div class="submit-btn">
                <img (click)="subscribeEmail(email.errors)" src="/assets/images/arrow-right.svg">
              </div>
            </div>
            <div class="errorRequired" *ngIf="showError && email.errors && (email.invalid || email.touched)">
              <small class="text-danger" *ngIf="email.errors?.['required']">
                Email is required
              </small>
              <small class="text-danger" *ngIf="email.errors?.['pattern']">
                Please provide a valid email address
              </small>
            </div>
            <div class="mail-desc">Only if you want it, 
              though! Subscribe to get early-bird access to new launches,
              promotions, and all things skincare.</div>
          </div>
        </div>
      </div>
      <div class="copy-right">
        <span>© 2023 ecommerce. All Rights Reserved.</span><br/>
        <span>V-1.0.0</span>
      </div>
    </div>
  </div>
</footer>